<template>
    <div id="address">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-home</v-icon> Address Information
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.address" readonly hide-details label="Home Address"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.postalCode" readonly hide-details label="Postal Code"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.country" readonly hide-details label="Country"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.city" readonly hide-details label="City"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.province" readonly hide-details label="Province"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col v-if="item.province == 'Other'" cols="12">
                        <v-text-field v-model="item.provinceOther" readonly hide-details label="Province"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-address',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>